export const priceDetailsSchema = {
  $schema: 'http://json-schema.org/draft-04/schema#',
  type: 'object',

  properties: {
    productPrintPositions: {
      type: 'array',
      items: { $ref: '#/$defs/printPosition' },
    },
    handlingCost: {
      type: 'string',
    },
    productPrice: {
      type: 'string',
    },
    totalPrice: {
      type: 'string',
    },
    productionDays: {
      type: 'string',
    },
    unitPrice: {
      type: 'string',
    },
  },
  required: [
    'productPrintPositions',
    'handlingCost',
    'productPrice',
    'totalPrice',
  ],
  additionalProperties: false,

  $defs: {
    printPosition: {
      type: 'object',
      properties: {
        printPositionSAPCode: {
          type: 'string',
        },
        printTechniqueSAPCode: {
          type: 'string',
        },
        numberOfColors: {
          type: 'integer',
        },
        width: {
          type: 'number',
        },
        height: {
          type: 'number',
        },
        printingCost: {
          type: 'string',
        },
        setupCost: {
          type: 'string',
        },
        subTotal: {
          type: 'string',
        },
      },
      required: ['printPositionSAPCode', 'setupCost', 'printingCost'],
      additionalProperties: false,
    },
  },
};

import { jsonSchemaValidator } from '@/validators';
import { PriceDetailsSetterType } from './typings/index';

export const priceDetails = {
  type: Object,
  required: true,
  default: (): PriceDetailsSetterType => ({
    productPrintPositions: [
      {
        printPositionSAPCode: '',
        setupCost: '',
        printingCost: '',
        printTechniqueSAPCode: '',
        numberOfColors: 0,
        width: 0,
        height: 0,
      },
      {
        printPositionSAPCode: '',
        setupCost: '',
        printingCost: '',
        printTechniqueSAPCode: '',
        numberOfColors: 0,
        width: 0,
        height: 0,
      },
    ],
    handlingCost: '',
    productPrice: '',
    totalPrice: '',
    productionDays: '',
    unitPrice: '',
    productQuantity: '',
  }),
  validator: (value: JSON): boolean => {
    console.log(
      'errors',
      jsonSchemaValidator('xx', value, priceDetailsSchema).errors
    );
    return (
      jsonSchemaValidator('price details setter', value, priceDetailsSchema)
        .errors.length === 0
    );
  },
};
